import { createReducer, on, Action } from '@ngrx/store';
import {
  loadDestinationCountry,
  loadDestinationCountrySuccess,
  loadDestinationCountryFailure,
  deleteDestCountry,
} from './destination-country.actions';
import {
  initialDestinationCountryState,
  DestinationCountryState,
} from './destination-country.state';
import { CountryInfo } from '@sharedModule/models/country.model';

export const destinationCountryReducer = createReducer(
  initialDestinationCountryState,
  on(loadDestinationCountry, state => ({ ...state, isLoading: true })),
  on(
    loadDestinationCountrySuccess,
    (state, { destinationCountries, sourceCurrency }) => ({
      ...state,
      data: destinationCountries,
      sourceCurrency: sourceCurrency,
      isLoading: false,
    })
  ),
  on(loadDestinationCountryFailure, (state, { error }) => ({
    ...state,
    error,
    data: [],
    sourceCurrency: undefined,
    isLoading: false,
  })),
  on(deleteDestCountry, (state, action): DestinationCountryState => {
    return {
      ...state,
      data: state.data?.filter(
        (destCountry: CountryInfo) =>
          destCountry.countryName !== action.destCountryName
      ),
    };
  })
);

export function reducer(
  state: DestinationCountryState | undefined,
  action: Action
): DestinationCountryState {
  return destinationCountryReducer(state, action);
}
